import React from 'react';

import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { borderColor } from '../../../lib/theme';
import { FieldCaption } from './field-caption.component';

interface ISettingsSectionProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  // Renders as a subgroup within another section: lighter heading and a rule
  // above it, so nesting reads as a hierarchy rather than a flat repeat.
  nested?: boolean;
  children: React.ReactNode;
}

export const SettingsSection: React.FC<ISettingsSectionProps> = ({ title, description, nested = false, children }) => (
  <Box
    mt={3}
    pt={nested ? 2 : 0}
    style={nested ? { borderTop: `1px solid ${borderColor}` } : undefined}
  >
    <Typography
      variant={nested ? 'subtitle2' : 'subtitle1'}
      component={nested ? 'h4' : 'h3'}
      style={{ fontWeight: 700, margin: 0 }}
    >
      {title}
    </Typography>
    {description && <FieldCaption>{description}</FieldCaption>}
    <Box mt={nested ? 1 : 2}>{children}</Box>
  </Box>
);
